/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import React from 'react';
import { Card, Layout, Page, Tooltip } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import MainMenu from 'src/components/containers/main-menu';
import VerticalTab from 'src/components/containers/vertical-tab';
import RelevanceSettings from 'src/components/containers/search-settings/relevance-setting';
import InCollectionSearchSetting from 'src/components/containers/search-settings/in-collection-setting';
import Redirects from 'src/components/containers/redirect';
import SuggestionDictionary from 'src/components/containers/suggestion-dictionary/suggestion-dictionary';
import SearchResultsPage from 'src/components/containers/search-page-display/search-results-page';
import InstantSearchWidget from 'src/components/containers/instant-search-display/instant-search-widget';
import ManualSynonym from 'src/components/containers/synonym/manual-synonym';
import StopWords from 'src/components/containers/stop-words/stop-word';
import NewSynonym from 'src/components/containers/synonym/new';
import NewRedirects from 'src/components/containers/redirect/new';
import EditRedirect from 'src/components/containers/redirect/edit';
import EditSynonym from 'src/components/containers/synonym/edit';
import NewSuggestionDictionary from 'src/components/containers/suggestion-dictionary/new';
import EditSuggestionDictionary from 'src/components/containers/suggestion-dictionary/edit';
import ExceededPlanNotification from 'src/components/containers/common/exceeded-plan-notifications';
import InstallationRemindStatusBanner from 'src/components/containers/common/installation-remind-status-banner';
import BannersNewVersion from 'src/components/containers/common/switchNewVersion/search';
import GuideTour from 'src/components/views/standard-search/guide-tour';
import WelcomePopup from 'src/components/containers/standard-search/welcome-popup';

import { routes } from 'src/routes';
import history from 'src/routes/history';
import { StandardSearchTab } from 'src/constants/search';
import { allowUsingNewSearchSettings } from 'src/helpers/search-settings-helper';
import testSearchIcon from 'src/assets/images/common/test-search-icon.png';

import * as themeSetupV3Action from 'actions/theme-setup-v3-actions';

const StandardSearch = props => {
  const { isNewSearch, themeSetupV2, getThemes, themes, i18n } = props;
  const [tab, setTab] = React.useState(routes.relevanceSettings.view());
  const [activeTab, setActiveTab] = React.useState(routes.relevanceSettings.view());

  let tabs = [
    {
      id: routes.relevanceSettings.view(),
      content: i18n.translate('AdminHTML.StandardSearch.Tabs.relevanceSettings'),
      'data-tour': 'search-guide-tour-step-1'
    },
    {
      id: routes.instantSearchWidget.view(),
      content: i18n.translate('AdminHTML.StandardSearch.Tabs.instantSearchWidget'),
      'data-tour': 'search-guide-tour-step-2'
    },
    {
      id: routes.searchResultsPage.view(),
      content: i18n.translate('AdminHTML.StandardSearch.Tabs.searchResultsPage'),
      'data-tour': 'search-guide-tour-step-3'
    },
    {
      id: routes.inCollectionSearch.view(),
      content: i18n.translate('AdminHTML.StandardSearch.Tabs.inCollection'),
      'data-tour': 'search-guide-tour-step-4'
    },
    {
      id: routes.synonym.view(),
      subTabs: [routes.synonym.new(), routes.synonym.edit()],
      content: i18n.translate('AdminHTML.StandardSearch.Tabs.manualSynonyms'),
      'data-tour': 'search-guide-tour-step-5'
    },
    {
      id: routes.suggestionDictionary.view(),
      subTabs: [routes.suggestionDictionary.new(), routes.suggestionDictionary.edit()],
      content: i18n.translate('AdminHTML.StandardSearch.Tabs.suggestionDictionary'),
      'data-tour': 'search-guide-tour-step-6'
    },
    {
      id: routes.redirect.view(),
      subTabs: [routes.redirect.new(), routes.redirect.edit()],
      content: i18n.translate('AdminHTML.StandardSearch.Tabs.redirects'),
      'data-tour': 'search-guide-tour-step-7'
    },
    {
      id: routes.stopWords.view(),
      content: i18n.translate('AdminHTML.StandardSearch.Tabs.stopWords'),
      'data-tour': 'search-guide-tour-step-8'
    }
  ];
  const childrenMap = {
    [routes.relevanceSettings.view()]: <RelevanceSettings />,
    [routes.instantSearchWidget.view()]: <InstantSearchWidget />,
    [routes.searchResultsPage.view()]: <SearchResultsPage />,
    [routes.inCollectionSearch.view()]: <InCollectionSearchSetting />,
    [routes.synonym.view()]: <ManualSynonym />,
    [routes.synonym.new()]: <NewSynonym />,
    [routes.synonym.edit()]: <EditSynonym />,
    [routes.suggestionDictionary.view()]: <SuggestionDictionary />,
    [routes.suggestionDictionary.new()]: <NewSuggestionDictionary />,
    [routes.suggestionDictionary.edit()]: <EditSuggestionDictionary />,
    [routes.redirect.view()]: <Redirects />,
    [routes.redirect.new()]: <NewRedirects />,
    [routes.redirect.edit()]: <EditRedirect />,
    [routes.stopWords.view()]: <StopWords />
  };

  // Hide In-Collection search tab for theme v1
  if (!themeSetupV2) {
    tabs = tabs.filter(t => t.id !== StandardSearchTab.inCollection);
  }

  // Only call first load, condition only []
  React.useEffect(() => {
    if (_.isEmpty(themes)) getThemes();
  }, []);

  React.useEffect(() => {
    const pathname = props.location.pathname;
    let activePath = pathname;
    if (pathname === routes.standardSearch.view()) {
      history.push(routes.relevanceSettings.view());
      return;
    }
    if (!tabs.find(item => item.id === pathname)) {
      const mainTab = tabs.find(itemTab =>
        (itemTab.subTabs || []).find(itemSub => itemSub === pathname)
      );
      activePath = mainTab?.id;
    }
    setTab(pathname);
    setActiveTab(activePath);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.pathname]);

  return (
    <div className="BC-Page BC-Page__StandardSearch">
      <MainMenu menuId="menu-search-standard-search" />
      <Page
        title={i18n.translate('AdminHTML.StandardSearch.StandardSearch.title')}
        subtitle={
          <div className="ref-to-test-search">
            <p>{i18n.translate('AdminHTML.StandardSearch.StandardSearch.description')}</p>
            {isNewSearch && (
              <Tooltip
                content={i18n.translate('AdminHTML.TestYourSearch.TestYourSearch.tooltip')}
                preferredPosition="above">
                <p onClick={() => history.push(routes.testYourSearch.view())}>
                  <img width={16} height={16} src={testSearchIcon} alt="pfs-test-search-icon" />
                  {i18n.translate('AdminHTML.TestYourSearch.TestYourSearch.title')}
                </p>
              </Tooltip>
            )}
          </div>
        }
        titleMetadata={<div className="standard-search-title"></div>}>
        <Layout>
          <Layout.Section>
            <div className="BC-Component__SearchGuideTour">
              <GuideTour />
            </div>
            <div data-tour="observable-parent" style={{ marginTop: '20px' }}>
              {/* Sticky notification for exceeded plan */}
              <ExceededPlanNotification />

              <BannersNewVersion />

              <InstallationRemindStatusBanner />
            </div>
          </Layout.Section>

          <Layout.Section>
            <div className="BC-Page StandardSearch__Content BC-Page__Fields">
              <Card sectioned>
                <VerticalTab
                  tabs={tabs}
                  scope="standard"
                  children={childrenMap[tab]}
                  selectedId={activeTab}
                  onSelected={tab => {
                    history.push(tab);
                  }}
                />
              </Card>
            </div>
          </Layout.Section>
        </Layout>
      </Page>
      <WelcomePopup />
    </div>
  );
};

const mapStateToProps = state => {
  const { searchSettings, oauth = {} } = state;
  const formValues = getFormValues('SearchSettingsForm')(state);
  const searchVersion = _.get(state.oauth, 'tenantApp.parseParams.searchVersion', '1.0');
  const isNewSearch = allowUsingNewSearchSettings(searchVersion);

  return {
    isNewSearch,
    themes: _.get(state.themeSetup, 'themes', []),
    themeSetupV2: _.get(oauth, 'tenantApp.adminAppFeatures.themeSetupV2', false),
    enableCollectionSearch: _.get(formValues, 'inCollectionSearch.enableCollectionSearch', false),
    getLoading: _.get(searchSettings, 'getLoading', false)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getThemes: () => dispatch(themeSetupV3Action.getThemes(ownProps.i18n))
});
export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(StandardSearch));
